import { CommonModule, ViewportScroller } from '@angular/common';
import {
  AfterViewInit,
  Component,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { Collective, User } from 'src/app/shared/model/user.model';
import { StorageService } from 'src/app/core/storage/storage.service';
import { MatIconModule } from '@angular/material/icon';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { Campaign } from 'src/app/shared/model/campaign.model';
import { MatMenuModule } from '@angular/material/menu';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import { lastValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { OrderService } from 'src/app/core/services/order.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalRequestAppraisalComponent } from '../modal-request-appraisal/modal-request-appraisal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import i18next from 'i18next';
import {
  CampaignRaffleStatus,
  CampaignTypes
} from 'src/app/shared/model/campaign.enum';
import { Translate } from 'src/app/shared/utils/translate';
import { RequestWarningModalComponent } from 'src/app/shared/components/request-warning-modal/request-warning-modal.component';
import { ModalIncompleteDataComponent } from 'src/app/shared/components/modal-incomplete-data/modal-incomplete-data.component';
import { CampaignInfoDialogComponent } from './campaign-info-dialog/campaign-info-dialog.component';

@Component({
  standalone: true,
  selector: 'app-landing2',
  templateUrl: './landing2.component.html',
  styleUrls: ['./landing2.component.scss'],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule,
    NgbCarouselModule,
    MatMenuModule,
    MatIconModule
  ]
})
export class Landing2Component implements OnInit, AfterViewInit {
  @ViewChild('carousel') carousel: any;
  user!: User;
  activeCar = 0;
  loading = true;

  requestsStatusClass: any = {
    NEW_REQUEST: { class: 'pending', text: 'newRequest' },
    PENDING_APPROVAL: { class: 'pending', text: 'pendingApproval' },
    APPROVED: { class: 'pending', text: 'approved' },
    SENT_TO_FACTORY: { class: 'pending', text: 'sentToFactory' },
    IN_PRODUCTION: { class: 'pending', text: 'production' },
    PENDING_REGISTRATION: { class: 'pending', text: 'pendingRegistration' },
    REGISTERED: { class: 'pending', text: 'registered' },
    PENDING_ASSIGNMENT: { class: 'pending', text: 'pendingAssignment' },
    PENDING_EXPEDITION: { class: 'pending', text: 'pendingExpedition' },
    IN_EXPEDITION: { class: 'pending', text: 'expedition' },
    IN_EXPEDITION_FACTORY: { class: 'pending', text: 'expeditionFactory' },
    PENDING_PICK_UP: { class: 'pending', text: 'pickUp' },
    ACTIVE: { class: 'active', text: 'activated' }
  };

  raffleStatusClass: any = {
    ASSIGNED: { class: 'active' },
    NOT_ASSIGNED: { class: 'pending' },
    PENDING_VALIDATION_OF_ASSIGNMENT: { class: 'pending' },
    DECLINED: { class: 'declined' }
  };

  requestsInfo = {
    endowmentLeasingEndowment: {
      total: 0,
      max: 0,
      left: 0
    },
    endowmentLeasingLeasing: {
      total: 0,
      max: 0,
      left: 0
    },
    leasing: {
      total: 0,
      max: 2,
      left: 0
    }
  };

  myVehicles: any[] = [];
  vehiclesSelect: any[] = [];
  requests: any[] = [];
  campaigns: Campaign[] = [];
  campaignTypesEnum = CampaignTypes;
  showScrollUp = false;
  employeeLeasing: any;

  constructor(
    private navigationService: NavigationService,
    private storageService: StorageService,
    private scroller: ViewportScroller,
    private vehiclesService: VehiclesService,
    private router: Router,
    private orderService: OrderService,
    public dialog: MatDialog,
    public translate: Translate
  ) {}

  @HostListener('window:scroll')
  onScroll() {
    if (!this.showScrollUp && window.scrollY > 100) {
      this.showScrollUp = true;
    } else if (this.showScrollUp && window.scrollY <= 100) {
      this.showScrollUp = false;
    }
  }

  async ngOnInit() {
    this.storageService.set('landing2', true);
    this.storageService.set('substitutionVehicle', null);
    this.storageService.set('substitutionVin', null);
    this.storageService.set('substitutionRequestNumber', null);
    this.storageService.set('pageList', 1);
    this.load();
  }

  async load() {
    this.loading = true;
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');

      for (const lease of this.user.leaseInfo) {
        if (lease.type === 'LEASING') {
          //endowmentLeasingLeasing
          this.requestsInfo.endowmentLeasingLeasing.max = lease.maxValue;
          let total = 0;

          //My vehicles
          try {
            const response = await lastValueFrom(
              this.vehiclesService.getVehiclesByVehicleTypeAndNIS(
                'ENDOWMENT_LEASING',
                'LEASING'
              )
            );
            for (let i = 0; i < response.length; i++) {
              const vehicle: any = response[i];
              vehicle.type = 'endowmentLeasingLeasing';
              if (!!vehicle.requestSubsNumber) {
                total -= 1;
              }
            }
            this.myVehicles.push(...response);
            const filteredVehicles = response.filter(
              (vehicle: any) => !vehicle.requestSubsNumber
            );
            this.vehiclesSelect.push(
              ...filteredVehicles.map((vehicle: any) => {
                const words = vehicle.model.split(' ');

                const shortenedModel =
                  'Sustituir por: ' + words.slice(0, 2).join(' ') + ' ';

                return {
                  model: shortenedModel,
                  plateNumber: vehicle.plateNumber
                };
              })
            );
            total += response.length;
          } catch (error) {
            console.error(error);
          }

          //Requests
          try {
            const leasingRequestsResponse = await lastValueFrom(
              this.orderService.showOrdersList('requests', true, 1, 'LEASING')
            );
            for (let i = 0; i < leasingRequestsResponse.requests.length; i++) {
              const request: any = leasingRequestsResponse.requests[i];
              request.type = 'endowmentLeasingLeasing';
              request.showVehicle = request.vehicle;
              if (request.showVehicle === null && request.newVehicle)
                request.showVehicle = request.newVehicle;
            }
            this.requests.push(...leasingRequestsResponse.requests);
            total += leasingRequestsResponse.requests.length;
          } catch (error) {
            console.error(error);
          }

          //Leasing Program
          try {
            const employeeLeasingResponse = await lastValueFrom(
              this.orderService.getEmployeeLeasing()
            );
            this.employeeLeasing = employeeLeasingResponse;
            this.storageService.set(
              'specialCompensationLeasing',
              this.employeeLeasing.sections[2].description
            );
          } catch (error) {
            console.error(error);
          }

          this.requestsInfo.endowmentLeasingLeasing.total = total;
          this.requestsInfo.endowmentLeasingLeasing.left =
            lease.maxValue - total;
          if (this.requestsInfo.endowmentLeasingLeasing.left < 0)
            this.requestsInfo.endowmentLeasingLeasing.left = 0;
          if (this.requestsInfo.endowmentLeasingLeasing.left > 0) {
            this.vehiclesSelect.push({
              model: 'Primera asignación arrendamiento',
              plateNumber: '',
              type: 'endowmentLeasingLeasing'
            });
          }
        } else if (lease.type === 'ENDOWMENT') {
          //endowmentLeasingEndowment
          this.requestsInfo.endowmentLeasingEndowment.max = lease.maxValue;
          let total = 0;

          //My vehicles
          try {
            const response = await lastValueFrom(
              this.vehiclesService.getVehiclesByVehicleTypeAndNIS(
                'ENDOWMENT_LEASING',
                'ENDOWMENT'
              )
            );
            for (let i = 0; i < response.length; i++) {
              const vehicle: any = response[i];
              vehicle.type = 'endowmentLeasingEndowment';
              if (!!vehicle.requestSubsNumber) {
                total -= 1;
              }
            }
            this.myVehicles.push(...response);
            const filteredVehicles = response.filter(
              (vehicle: any) => !vehicle.requestSubsNumber
            );
            this.vehiclesSelect.push(
              ...filteredVehicles.map((vehicle: any) => {
                const words = vehicle.model.split(' ');

                const shortenedModel =
                  'Sustituir por: ' + words.slice(0, 2).join(' ') + ' ';

                return {
                  model: shortenedModel,
                  plateNumber: vehicle.plateNumber
                };
              })
            );
            total += response.length;
          } catch (error) {
            console.error(error);
          }

          //Requests
          try {
            const endowmentRequestsResponse = await lastValueFrom(
              this.orderService.showOrdersList('requests', true, 1, 'ENDOWMENT')
            );
            for (
              let i = 0;
              i < endowmentRequestsResponse.requests.length;
              i++
            ) {
              const request: any = endowmentRequestsResponse.requests[i];
              request.type = 'endowmentLeasingEndowment';
              request.showVehicle = request.vehicle;
              if (request.showVehicle === null && request.newVehicle)
                request.showVehicle = request.newVehicle;
            }
            this.requests.push(...endowmentRequestsResponse.requests);
            total += endowmentRequestsResponse.requests.length;
          } catch (error) {
            console.error(error);
          }

          this.requestsInfo.endowmentLeasingEndowment.total = total;
          this.requestsInfo.endowmentLeasingEndowment.left =
            lease.maxValue - total;
          if (this.requestsInfo.endowmentLeasingEndowment.left < 0)
            this.requestsInfo.endowmentLeasingEndowment.left = 0;
          if (this.requestsInfo.endowmentLeasingEndowment.left > 0) {
            this.vehiclesSelect.push({
              model: 'Primera asignación dotación',
              plateNumber: '',
              type: 'endowmentLeasingEndowment'
            });
          }
        }
      }
      this.setVehiclesLeasingLeft();
    }

    try {
      await this.getCampaignsVehicles();
    } catch (error) {
      console.error(error);
    }

    // Bloqueo el botón para que no pueda solicitar una campaña más de una vez
    const requestedCampaignIds = new Set(
      this.requests
        .filter((req) => !!req.campaign?.id)
        .map((req) => req.campaign?.id)
    );
    this.campaigns.forEach((campaign) => {
      campaign.isRequested = requestedCampaignIds.has(campaign.id);
    });

    this.loading = false;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('landing2');
    }, 0);
  }

  needUploadData(): boolean {
    if (!!this.user) {
      return (
        !this.user.contact?.leasingNumber ||
        !this.user.email ||
        !this.user.address?.roadType ||
        !this.user.address?.street ||
        !this.user.address?.city ||
        !this.user.address?.stateCode
      );
    } else {
      return false;
    }
  }

  async setVehiclesLeasingLeft() {
    //EMPLOYEE_LEASING
    let total = 0;

    try {
      const response = await lastValueFrom(
        this.vehiclesService.getVehiclesByVehicleTypeAndNIS('LEASING')
      );
      for (let i = 0; i < response.length; i++) {
        const vehicle: any = response[i];
        vehicle.type = 'employeeLeasing';
        if (!!vehicle.requestSubsNumber) {
          total -= 1;
        }
      }
      if (response.length > 0 && this.needUploadData()) {
        this.dialog.open(ModalIncompleteDataComponent);
      }
      this.myVehicles.push(...response);
      total += response.length;
    } catch (error) {
      console.error(error);
    }

    //Requests
    try {
      const leasingResponse = await lastValueFrom(
        this.orderService.showOrdersList(
          'requests',
          true,
          1,
          undefined,
          'LEASING'
        )
      );
      for (let i = 0; i < leasingResponse.requests.length; i++) {
        const request: any = leasingResponse.requests[i];
        request.type = 'employeeLeasing';
        request.showVehicle = request.vehicle;
        if (request.showVehicle === null && request.newVehicle)
          request.showVehicle = request.newVehicle;
      }
      if (leasingResponse.requests.length > 0 && this.needUploadData()) {
        this.dialog.open(ModalIncompleteDataComponent);
      }
      this.requests.push(...leasingResponse.requests);
      total += leasingResponse.requests.length;
    } catch (error) {
      console.error(error);
    }

    this.requestsInfo.leasing.total = total;
    this.requestsInfo.leasing.left = this.requestsInfo.leasing.max - total;
    if (this.requestsInfo.leasing.left < 0) this.requestsInfo.leasing.left = 0;
  }

  scrollDown(target: string) {
    this.scroller.scrollToAnchor(target);
  }

  scrollToTop() {
    this.scroller.scrollToPosition([0, 0]);
    this.showScrollUp = false;
  }

  navigateToExternalSite(url: string): void {
    window.open(url, '_blank');
  }

  hasVehiclesToReplace(type: string): boolean {
    const result = this.myVehicles.some((vehicle) => {
      return (
        vehicle.type === type &&
        (vehicle.requestSubsNumber === null ||
          vehicle.requestSubsNumber === undefined)
      );
    });
    return result;
  }

  requestCar(type: string) {
    if (type === 'employeeLeasing' && this.needUploadData()) {
      this.dialog.open(ModalIncompleteDataComponent);
    } else {
      if (this.hasVehiclesToReplace(type)) {
        const dialogRef = this.dialog.open(RequestWarningModalComponent);
        dialogRef.componentInstance.onResponse.subscribe(
          (response: boolean) => {
            if (response) this.requestCarFunc(type);
            else setTimeout(() => this.scrollToTop(), 500);
          }
        );
      } else this.requestCarFunc(type);
    }
  }

  requestCarFunc(type: string) {
    this.storageService.removeItem('substitutionVin');
    this.storageService.removeItem('substitutionRequestNumber');
    this.storageService.removeItem('substitutionVehicle');
    this.storageService.set('requestCarType', type);
    switch (type) {
      case 'endowmentLeasingEndowment':
      case 'endowmentLeasingLeasing':
        this.router.navigate(['/endowment_leasing']);
        break;
      case 'employeeLeasing':
        const canRequestLeasingMessage = this.canRequestLeasing(
          this.vehiclesSelect
        );
        const infoRequestLeasingMessage = this.infoRequestLeasing();
        if (canRequestLeasingMessage) {
          this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t(canRequestLeasingMessage),
              close: true,
              theme: 'ligth'
            }
          });
          break;
        } else if (infoRequestLeasingMessage) {
          const dialogRef = this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t(infoRequestLeasingMessage),
              close: true,
              theme: 'ligth'
            }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.router.navigate(['/employee_leasing']);
          });
        } else {
          this.router.navigate(['/employee_leasing']);
        }
        break;
      default:
        this.router.navigate(['/endowment_leasing']);
        break;
    }
  }

  selectCar(index: number) {
    this.activeCar = index;
    this.carousel.select(index.toString());
  }

  selectCarCarousel(event: any) {
    if (event && event.current) {
      this.activeCar = parseInt(event.current);
    }
  }

  openInfoAndConditions(campaign: any): void {
    this.dialog.open(CampaignInfoDialogComponent, {
      width: '900px',
      maxWidth: '90vw',
      data: { info: campaign.info }
    });
  }

  requestCampaign(campaign: Campaign, selectedVehicle: any) {
    //Reset storage values
    this.storageService.removeItem('substitutionVin');
    this.storageService.removeItem('substitutionRequestNumber');
    this.storageService.removeItem('substitutionVehicle');
    this.storageService.removeItem('requestCarType');

    const matchingVehicle = this.myVehicles.find(
      (vehicle) => vehicle.plateNumber === selectedVehicle.plateNumber
    );

    let requestCarType;

    if (!!matchingVehicle) {
      this.storageService.set('substitutionVin', matchingVehicle.VIN);
      this.storageService.set(
        'substitutionRequestNumber',
        matchingVehicle.requestNumber
      );
      this.storageService.set('substitutionVehicle', matchingVehicle);
      requestCarType = matchingVehicle.type;
      this.storageService.set('requestCarType', requestCarType);
    } else {
      requestCarType = selectedVehicle.type;
      this.storageService.set('requestCarType', requestCarType);
    }

    let type;

    if (requestCarType === 'endowmentLeasingLeasing') {
      type = 'LEASING';
    } else if (requestCarType === 'endowmentLeasingEndowment') {
      type = 'ENDOWMENT';
    } else {
      type = '';
    }

    if (campaign.requestType === type || campaign.requestType === null) {
      this.router.navigate(['/campaign', { id: campaign.id }]);
    } else {
      this.dialog.open(FeedbackModalComponent, {
        width: '400px',
        data: {
          text:
            i18next.t('campaignNotAvailable') +
            this.translate.translateCampaignType(type),
          close: true,
          theme: 'dark'
        }
      });
    }
  }

  canRequestMoreVehicles() {
    if (!this.isExp() && this.requestsInfo.endowmentLeasingEndowment.left > 0)
      return true;
    if (this.requestsInfo.endowmentLeasingLeasing.left > 0) return true;
    if (!this.isExp() && this.requestsInfo.leasing.left > 0) return true;
    if (this.requests.length > 0) return true;
    return false;
  }

  getContractDates(deliveryDate: any): {
    deliveryDateParsed: Date;
    contractEndingDate: Date;
  } {
    const deliveryDateParsed = new Date(deliveryDate);
    const contractEndingDate = new Date(
      new Date(deliveryDate).setMonth(deliveryDateParsed.getMonth() + 9)
    );
    return {
      deliveryDateParsed,
      contractEndingDate
    };
  }

  canRequestLeasing(vehicle: any, considerContractEndingTime = false) {
    const dates = this.getContractDates(vehicle.deliveryDate);

    const isLeasingProgramInactiveMsg = !this.employeeLeasing?.status?.active
      ? this.employeeLeasing?.status?.description
      : null;
    const petitionerHasDebtMsg = !this.user?.leasing
      ? i18next.t('petitionerHasDebt')
      : null;
    const contractEndingTimeUnderMsg =
      considerContractEndingTime &&
      dates &&
      dates.contractEndingDate > new Date()
        ? i18next.t('contractEndingTimeUnder')
        : null;

    return (
      isLeasingProgramInactiveMsg ||
      petitionerHasDebtMsg ||
      contractEndingTimeUnderMsg
    );
  }

  infoRequestLeasing() {
    const infoLeasingProgramInactiveMsg = this.employeeLeasing?.info?.active
      ? this.employeeLeasing?.info?.description
      : null;

    return infoLeasingProgramInactiveMsg;
  }

  onVehicleOptionSelected(vehicle: any, option: string) {
    switch (option) {
      case 'replace':
        if (vehicle.type === 'employeeLeasing') {
          const canRequestLeasingMessage = this.canRequestLeasing(
            vehicle,
            true
          );
          const infoRequestLeasingMessage = this.infoRequestLeasing();
          if (canRequestLeasingMessage) {
            this.dialog.open(FeedbackModalComponent, {
              width: '400px',
              data: {
                text: i18next.t(canRequestLeasingMessage),
                close: true,
                theme: 'ligth'
              }
            });
            break;
          } else if (infoRequestLeasingMessage) {
            this.dialog.open(FeedbackModalComponent, {
              width: '400px',
              data: {
                text: i18next.t(infoRequestLeasingMessage),
                close: true,
                theme: 'ligth'
              }
            });
          }
        }
        this.storageService.set('substitutionVin', vehicle.VIN);
        this.storageService.set(
          'substitutionRequestNumber',
          vehicle.requestNumber
        );
        this.storageService.set('substitutionVehicle', vehicle);
        this.storageService.set('requestCarType', vehicle.type);
        if (vehicle.type === 'employeeLeasing') {
          this.router.navigate(['/employee_leasing']);
        } else {
          this.router.navigate(['/endowment_leasing']);
        }
        break;
      case 'appraise':
        if (!vehicle.requestNumber) return;
        const dialogRef = this.dialog.open(ModalRequestAppraisalComponent, {
          data: vehicle.requestNumber
        });
        dialogRef.componentInstance.confirmAppraisalEmitter.subscribe(() => {
          this.myVehicles.forEach((req: any) => {
            if (req.requestNumber === vehicle.requestNumber) {
              req.appraisalRequested = true;
            }
          });
        });
        break;
      case 'book':
        if (!vehicle.requestNumber) return;
        this.router.navigate(['/book-vehicle', vehicle.requestNumber]);
        break;
      case 'viewRequestDetail':
        if (!vehicle.requestNumber) return;
        if (vehicle.showId && vehicle.requestType === 'LEASING')
          this.storageService.set('vehicleShowId', vehicle.showId);
        else this.storageService.removeItem('vehicleShowId');
        this.router.navigate(['/detail-request', vehicle.requestNumber]);
        break;
      case 'cancelBooking':
        if (!vehicle.requestNumber) return;
        this.openCancelModal(vehicle.requestNumber);
        break;
      case 'liveTheExperience':
        let url = 'https://www.youtube.com/@tuseat';
        if (vehicle.brand && vehicle.brand === 'CUPRA')
          url = 'https://www.youtube.com/@cupra_esp';
        window.open(url, '_blank');
        break;
      case 'yourCarInfo':
        if (vehicle.infoUrl) window.open(vehicle.infoUrl, '_blank');
        else window.open('https://www.cupraofficial.es/', '_blank');
        break;
    }
  }

  async getCampaignsVehicles(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.vehiclesService.getCampaignsVehicles(this.user.category).subscribe({
        next: (res) => {
          this.campaigns = res;
          for (let i = 0; i < this.campaigns.length; i++) {
            const campaign = this.campaigns[i];
            let minFee = Infinity;

            campaign.vehicleGroups.forEach((vehicleGroup) => {
              if (vehicleGroup.prices.fee < minFee) {
                minFee = vehicleGroup.prices.fee;
              }
            });

            campaign.minFee = minFee;
          }
          resolve();
        },
        error: (err: HttpErrorResponse) => {
          reject(err);
        }
      });
    });
  }

  openCancelModal(requestNumber: string): void {
    const dialogRef = this.dialog.open(FeedbackModalComponent, {
      data: {
        cancelOrder: true,
        text: i18next.t('cancelModal'),
        theme: 'ligth'
      }
    });

    dialogRef.componentInstance.confirmCancelOrderEmitter.subscribe(() => {
      if (requestNumber) {
        this.cancelRequest(requestNumber, null);
      }
    });
  }

  cancelRequest(requestNumber: string, reasonValue: string | null): void {
    this.loading = true;
    this.orderService.cancelRequest(requestNumber, reasonValue).subscribe({
      next: () => {
        this.requests = this.requests.filter((req: any) => {
          if (requestNumber === req.requestNumber) {
            if (req.campaign && req.campaign.id) {
              const canceledCampaign = this.campaigns.find(
                (c) => c.id === req.campaign.id
              );
              if (canceledCampaign) {
                canceledCampaign.isRequested = false;
              }
            }
            if (req.type === 'endowmentLeasingEndowment') {
              this.requestsInfo.endowmentLeasingEndowment.left += 1;
              if (this.requestsInfo.endowmentLeasingEndowment.left === 1) {
                this.vehiclesSelect.push({
                  model: 'Primera asignación dotación',
                  plateNumber: '',
                  type: 'endowmentLeasingEndowment'
                });
              }
            } else if (req.type === 'endowmentLeasingLeasing') {
              this.requestsInfo.endowmentLeasingLeasing.left += 1;
              if (this.requestsInfo.endowmentLeasingLeasing.left === 1) {
                this.vehiclesSelect.push({
                  model: 'Primera asignación arrendamiento',
                  plateNumber: '',
                  type: 'endowmentLeasingLeasing'
                });
              }
            } else {
              this.requestsInfo.leasing.left += 1;
            }
            return false;
          }
          return true;
        });
        this.myVehicles.forEach((req: any) => {
          if (req.requestSubsNumber === requestNumber) {
            req.requestSubsNumber = null;
          }
        });

        this.loading = false;
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('errorCancel'),
            close: true,
            theme: 'ligth'
          }
        });
        console.error(err);
      }
    });
  }

  getRequestStatusClass(status: string): string {
    return this.requestsStatusClass[status].class;
  }

  getRequestStatusText(request: any): string {
    if (
      (request.type === 'endowmentLeasingLeasing' ||
        request.type === 'endowmentLeasingEndowment') &&
      request.requestStatus === 'PENDING_APPROVAL'
    )
      return i18next.t('pendingProcessing');
    return this.requestsStatusClass[request.requestStatus].text;
  }

  getRequestStatusIcon(status: string): string {
    if (status === 'ACTIVE') return '../../../assets/icons/check_green.svg';
    else return '../../../assets/icons/emergency_home.svg';
  }

  getRaffleStatusClass(status: string): string {
    return this.raffleStatusClass[status].class;
  }

  getRaffleStatusIcon(status: string): string {
    if (status === CampaignRaffleStatus.ASSIGNED) {
      return '../../../assets/icons/check_green.svg';
    } else if (status === CampaignRaffleStatus.DECLINED) {
      return '../../../assets/icons/gpp_maybe.svg';
    } else {
      return '../../../assets/icons/emergency_home.svg';
    }
  }

  isExp() {
    if (!this.user) return false;
    if (!this.user.groupType) return false;
    return this.user.groupType === Collective.EXP;
  }

  getVehicleReturnDate(vehicle: any) {
    /* TODO: descomentar cuando Salesforce comrpruebe que aplican la logica de la fecha de devolucion entrega +12 meses
    if (vehicle.returnDate && vehicle.returnDate !== 'null')
      return vehicle.returnDate;
    */
    if (vehicle.deliveryDate && vehicle.deliveryDate !== 'null') {
      const date = new Date(vehicle.deliveryDate);
      date.setMonth(date.getMonth() + 12);
      return date.toISOString().split('T')[0];
    }
    return 'No disponible';
  }

  isValidDate(date: any) {
    if (date && date !== 'null') {
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    }
    return false;
  }
}
